import { ButtonGroup, ButtonIcon, Card, Icon, Tooltip, CardV2 } from 'pepsico-ds'
import React, { useEffect, useState } from 'react'
import { appNames } from '../../constants/appNames'
import { useDispatch, useSelector } from 'react-redux'
import swal from 'sweetalert';
import { message } from 'antd';
import InfoIcon from '../Icons/InfoIcon';
import Vector from '../../assets/Vector.png'
import { formatNumberWithCommas, returnHyphenIfNull, splitValueWithUnit } from '../../utils/utils';
import { getUserClaims } from '../../utils/auth/unified-auth';
import SCMModal from '../Modal/SCMModal';
import { showChartDisplayError, useButtonItemsArray, vlaidateLandingPageFilters } from './CardUtils';
import BuyerConButtonIcon from "../Button/BuyerConButtonIcon"
import CustomButtons from './CustomButtons';
import EDF_checked from "../../../src/assets/EDF_checked.svg";
import { staticNotes } from '../../constants/staticNotes';

function SCMCard({ data, capability, selectedYear, userDataLandingPage, landingPageFilters, disabled=false }) {
    const userData = useSelector((state) => state?.localData?.data?.oktaUserData);
    const [openModal, setOpenModal] = useState(false);
    const [appName, setAppName] = useState('Should Cost Modelling');
    const [buttonGroupItems, setButtonGroupItems] = useState([])
    /* istanbul ignore next */
    useEffect(() => {
        if (data && Object.keys(data).length > 0) {
            const tempItems = data && data?.apps && data?.apps.length > 0 ? data?.apps?.filter(item => item.isActive)?.map((app) => ({
                label: app.app,
                chartDisplay: app.chartDisplay,
                onClick: () => window.open(app.url, "_blank"), // Opens the app in a new tab
                icon: "info"
            })) : [];
            console.log(tempItems)
            setButtonGroupItems(tempItems)
        }
    }, [data])

    const buttonGroupDropdownItems = useButtonItemsArray(buttonGroupItems, setAppName, landingPageFilters, setOpenModal, openModal, capability);

    const enableChartDisplayButton = [appNames.shouldCostModelling].includes(capability) &&
        buttonGroupDropdownItems.length < 3 && buttonGroupDropdownItems?.[1]?.chartDisplay;

    const buttonStyle = {
        marginTop: '10px',
        border: 'none',
        background: 'transparent',
        cursor: 'grab',
        fontSize: '20px',
      }

      // console.log("scmcarddata", data)
      // console.log("scmcapability", capability)
      // console.log("scmselectedYear", selectedYear)
    return (
        <>
            <div className="kpi-card-header">
                                <div className="kpi-card-title" title={data?.title}>
                                    {data?.title}
                                    {
                                        data?.edfintegrated &&
                                        <Tooltip direction="bottom" text={staticNotes.EDF_NOTE} style={{ marginTop: 13 }}>
                                            <img src={EDF_checked} alt='image' style={{ width: '18px', height: '22px', marginLeft: "8px", overflow:"visible" }} />
                                        </Tooltip>
                                    }
                                </div>
                                {
                                    buttonGroupDropdownItems.length === 2 ?
                                        <div className="kpi-card-header-icons">
                                            {BuyerConButtonIcon(enableChartDisplayButton, landingPageFilters, setOpenModal, openModal, capability, disabled)}
                                        </div>
                                        :
                                        <ButtonGroup
                                            groupDisabled = {disabled}
                                            itemCount={1}
                                            items={buttonGroupDropdownItems}
                                            showMore
                                            size="medium"
                                            className="kpiCardButtomGroup"
                                        />
                                }
                            </div>
                            {
                                <div className="kpi-card-middle-content">
                                    <div className="kpi-card-middle-content-left" style={{ width: '75%' }}>
                                        {
                                            data?.currentYearValue ?
                                                <div className="kpi-card-alphanumeric-value">
                                                    {

                                                        // <>
                                                        //     <div className='kpi-card-numeric-value'>
                                                        //         {data?.savingOpportunityIdentified}
                                                        //     </div>
                                                        // </>
                                                        <>
                                                        <div className='kpi-card-numeric-value' style={{ fontSize: 50 }}>
                                                            {splitValueWithUnit(data?.currentYearValue)?.['numericValue']}
                                                        </div>
                                                        <div className="kpi-card-alpha-value" style={{ display: "flex", alignItems: 'flex-end' }}>
                                                            {splitValueWithUnit(data?.currentYearValue)?.['unit']}
                                                        </div>
                                                        <InfoIcon style={{ 'line-height': '4rem' }} text={data?.description} direction='right'/>
                                                    </>
                                                    }

                                                </div>
                                                :
                                                <div className="kpi-card-alphanumeric-value">
                                                    <div className='kpi-card-numeric-value'>N/A<sup><InfoIcon text="Data is not available for the given filter combination. Please adjust your selection." direction='right'/></sup></div>
                                                </div>
                                        }
                                        {/* <div className="kpi-card-numeric-value-tagline">Savings Opportunity Identified</div> */}
                                        <div className="kpi-card-numeric-value-tagline">{data?.subDescription}</div>
                                        {/* <div className="kpi-card-last-update">Last Update: {returnHyphenIfNull(data?.lastUpdate)} | Refresh Frequency: {returnHyphenIfNull(data?.refreshFrequency)}</div> */}
                                        {/* <div className="kpi-card-last-update" style={{ width: '100%', textAlign: 'left' }}>{(data?.lastUpdate)} {data?.refreshFrequency ? ' | ' + data.refreshFrequency : ''}</div> */}
                                        <div className="kpi-card-last-update" style={{ width: '100%', textAlign: 'left' }}>{data?.lastUpdate && data?.refreshFrequency? `${data.lastUpdate} | ${data.refreshFrequency}`: data?.lastUpdate || data?.refreshFrequency || ''}</div>
                                    </div>
                                    <div className="kpi-card-middle-content-right">
                                        <div className="kpi-card-last-year-value">
                                            <span className="last-year">LY</span>
                                            {
                                                data?.lastYearValue ?
                                                    <>
                                                        <span className="last-year-value">{data?.lastYearValue}</span>
                                                    </> : <span className="last-year-value">N/A</span>
                                            }
                                        </div>
                                        <div className="kpi-card-last-year-value" style={{ display: 'flex', flexDirection: 'column', alignItems: 'end', height: '100%' }}>
                                            {
                                                data?.percentage ?
                                                    <>
                                                        <div className="kpi-card-percentage-value" style={{ width: 'fit-content', padding: '4px 9px' }}>{data?.percentage}%
                                                            <Icon
                                                                alt="alt value"
                                                                icon={parseFloat(data?.percentage) == 0 ? "" : (parseFloat(data?.percentage) > 0 ? "arrow_upward" : "arrow_downward")}
                                                                size="small"
                                                                style={{ color: '#fff' }}
                                                            />
                                                        </div>
                                                    </> : <span className="kpi-card-percentage-value" style={{ width: 'fit-content', padding: '4px 9px' }}>0</span>
                                            }
                                            {
                                                data?.count ?
                                                    <>
                                                        <div className="kpi-card-percentage-value" style={{ marginTop:10, width: 'fit-content', padding: '4px 9px' }}>{data?.count}
                                                        </div>
                                                    </> : <span className="kpi-card-percentage-value" style={{ marginTop:10, width: 'fit-content', padding: '4px 9px' }}>0</span>
                                            }
                                            <span className="archlet-card-text">#SKUs Modeled</span>
                                        </div>
                                        
                                    </div>
                                </div>
                            }
                            <div className="kpi-card-footer">
                                <CustomButtons appList={data?.apps} disabled={disabled}/>
                            </div>



            {
                openModal  && capability == appNames.shouldCostModelling && <SCMModal openModal={openModal} setOpenModal={setOpenModal} userData={userData} selectedYear={selectedYear} capability={capability} userDataLandingPage={userDataLandingPage} landingPageFilters={landingPageFilters} />
            }
        </>
    )
}

export default SCMCard
